const helperPlugin = {
	install(app) {
		app.config.globalProperties.generateUUID = function () {
			return URL.createObjectURL(new Blob([])).slice(-36);
		};
		app.config.globalProperties.secondsToMinSecPadded = function (time) {
			const minutes = `${Math.floor(time / 60)}`.padStart(2, '0');
			const seconds = `${time - minutes * 60}`.padStart(2, '0');
			return `${minutes}:${seconds}`;
		};
		app.config.globalProperties.ajax = function (action = null, requestBody = {}) {
			return new Promise(function (resolve, reject) {
				if (action && window.aktionCustomQuizAjax && window.aktionCustomQuizAjax.ajax_url && window.aktionCustomQuizAjax.nonce) {
					let data = new FormData();
					data.append('action', action);
					data.append('security', window.aktionCustomQuizAjax.nonce);
					if (requestBody) {
						for (const fieldName in requestBody) {
							data.append(fieldName, requestBody[fieldName]);
						}
					}
					fetch(window.aktionCustomQuizAjax.ajax_url, {
						method: 'POST',
						credentials: 'same-origin',
						body: data,
					})
						.then(function (response) {
							return response.json();
						})
						.then(function (wpResponse) {
							resolve(wpResponse);
						})
						.catch((error) => {
							reject(error);
						});
				} else {
					reject(new Error('Dependencies not available'));
				}
			});
		};
		app.config.globalProperties.getImageUrlById = async function (imageId) {
			'use strict';
			let imageURL = '';
			let wp = window.wp;
			if (imageId) {
				let attachment = await wp.media.attachment(imageId);
				await attachment.fetch();
				if (attachment.attributes && attachment.attributes.url) {
					imageURL = attachment.attributes.url;
				}
			}
			return imageURL;
		};
		app.config.globalProperties.isValidEmail = function (email) {
			return String(email)
				.toLowerCase()
				.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		};
		app.config.globalProperties.isUserLoggedIn = function () {
			let isUserLoggedIn = false;
			if (window.aktionCustomQuizAjax && window.aktionCustomQuizAjax.is_user_logged_in) {
				isUserLoggedIn = true;
			}
			return isUserLoggedIn;
		};
		app.config.globalProperties.getCurrentPostId = function () {
			let currentPostId = false;
			if (window.aktionCustomQuizAjax && window.aktionCustomQuizAjax.post_id) {
				currentPostId = window.aktionCustomQuizAjax.post_id;
			}
			return currentPostId;
		};
		// Max achievable score for a quiz (mirrors WordPressHooks::get_max_score).
		// Used only for display fallback — the server value is authoritative.
		app.config.globalProperties.computeQuizMaxScore = function (quizOptions) {
			let max = 0;
			if (!quizOptions || !quizOptions.questions) {
				return 0;
			}
			let type = quizOptions.quizType;
			quizOptions.questions.forEach(function (question) {
				if (type === 'guess-answers') {
					if (question.quizType === type) {
						max += Math.abs(parseInt(question.score) || 0);
					}
				} else if (question.choices && question.choices.length) {
					let best = 0;
					question.choices.forEach(function (choice) {
						if (choice.isCorrect) {
							let score = Math.abs(parseInt(choice.score) || 0);
							if (score > best) {
								best = score;
							}
						}
					});
					max += best;
				}
			});
			return max;
		};
		// Resolve the frontend column layout for a quiz. Sections (when present on
		// questions) group questions into one column each and override columnLayout.
		app.config.globalProperties.getQuizLayout = function (quizOptions) {
			let questions = (quizOptions && quizOptions.questions ? quizOptions.questions : [])
				.slice()
				.sort(function (a, b) {
					return (a.order || 0) - (b.order || 0);
				});

			let order = [];
			let map = {};
			let hasSection = false;
			questions.forEach(function (question) {
				let section = (question.section || '').trim();
				if (section) {
					hasSection = true;
				}
				let key = section || '__none__';
				if (!(key in map)) {
					map[key] = [];
					order.push(key);
				}
				map[key].push(question);
			});

			if (hasSection) {
				let sections = order.map(function (key) {
					return { label: key === '__none__' ? '' : key, questions: map[key] };
				});
				return { columns: sections.length, sections: sections };
			}

			let layout = (quizOptions && quizOptions.columnLayout) || 'auto';
			let columns;
			if (layout === 'single') {
				columns = 1;
			} else if (layout === 'double') {
				columns = 2;
			} else {
				columns = questions.length >= 12 ? 2 : 1;
			}
			return { columns: columns, sections: null };
		};
	},
};

export default helperPlugin;
